import { request } from "../request"

export interface UserSceneCountResponse {
  success: boolean
  scene: string
  count: number
}

/**
 * Total users in a scene — distinct from getUserBandsCount's follower
 * count, used by the event-creation "Notify Followers" copy to show how
 * many people will see the event in their scene feed/digest regardless of
 * the notify toggle. Shared with the mobile app (GET /api/v1/users/scene_count).
 */
export const getUserSceneCount = async (
  scene: string,
): Promise<UserSceneCountResponse> => {
  return request({
    queryKey: [
      "user_scene_count",
      {
        path: "/api/v1/users/scene_count",
        options: { method: "GET" },
        params: { scene },
      },
    ],
  })
}
